import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-consolidated-backup-report",
  templateUrl: "./backup-report.component.html",
  styleUrls: ["./backup-report.component.css"],
})
export class ConsolidatedBackupReportComponent implements OnInit {
  currentTab: string = "snapshots";

  constructor() {}

  ngOnInit(): void {}
}
